import { Type } from '@angular/core';
import { DynamicModelType } from './models';

export type DynComponentMapping = { [key in DynamicModelType]?: Type<unknown> };
